import { FaRegEye } from "react-icons/fa";
import { useStore } from "../StateProvider";
import Select from "react-select";
const Dropdown = ({
  className = { field: "", lable: "", input: "" },
  name = "",
  label = "",
  doubleline = false,
  list = [],
  onchange = () => {},
  onInputChange = () => {},
  onAdd,
  onView,
}) => {
  const store = useStore();
  let props = store.getprops(name) || {};

  if (!props.hidden) {
    return (
      <div
        className={
          (className.field === ""
            ? "flex text-[12px] md:text-[14px] md:w-full md:h-full px-0 md:px-3 "
            : className.field) +
          (doubleline
            ? " flex-col md:gap-1 "
            : " flex-row items-center md:gap-3 ")
        }
      >
        <label
          className={
            className.lable === ""
              ? "w-fit  min-w-[150px] max-w-full"
              : className.lable
          }
          onClick={() => {
            document.getElementById(name).focus();
          }}
        >
          {label}
          {props.mandatory && (
            <span className="text-[#ff2828] text-[14px] h-fit">*</span>
          )}
        </label>
        <div
          className={
            "group flex w-full rounded-lg" +
            (props.mandatory && props.show
              ? " rounded-2xl border-2 border-[#ff2828] "
              : "")
          }
        >
          <Select
            id={name}
            styles={{
              singleValue: (provided, state) => ({
                ...provided,
                color: state.isDisabled ? "#000" : provided.color, // Bright black color when disabled
              }),
              placeholder: (provided, state) => ({
                ...provided,
                color: state.isDisabled ? "#000" : provided.color, // Also placeholder color if needed
              }),
              input: (provided, state) => ({
                ...provided,
                color: state.isDisabled ? "#000" : provided.color, // Input text color when disabled
              }),
               control: (base) => ({
                    ...base,
                    minHeight: '32px',  
                    height: '32px',
                    fontSize: '0.8rem',
                  }),
            }}
            className={
              (props.readonly
                ? " text-opacity-100 text-[#000] border-black "
                : "") +
              (className.input === ""
                ? " w-full rounded-lg "
                : className.input) +
              (!doubleline ? " p-2 " : " px-2 py-1 ")
            }
            placeholder={"Search for " + label.replace(":", "")}
            name={name}
            options={list}
            value={list.find((item) => item.value == store.getvalue(name))}
            onInputChange={(event) => {
              onInputChange(event);
            }}
            onChange={(event) => {
              store.setvalue(name, event.value);
              onchange(event.value);
            }}
            isDisabled={props.readonly}
          />
          {store.getvalue(name) === "" && onAdd != undefined && (
            <button
              className="w-[10%] group-hover:bg-tertiary font-bold rounded-r-lg"
              onClick={() => {
                onAdd();
              }}
            >
              +
            </button>
          )}
          {store.getvalue(name) !== "" && onView != undefined && (
            <button
              className="w-[10%] group-hover:bg-tertiary font-bold rounded-r-lg flex justify-center items-center"
              onClick={() => {
                onView(store.getvalue(name));
              }}
            >
              <FaRegEye />
            </button>
          )}
        </div>
      </div>
    );
  }
};

export default Dropdown;
